/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation, useQuery } from '@tanstack/react-query';
import { IGroundWaterZone } from '../../../../@types/model/borehole/groundWaterZone/groundWaterZone';
import { IGroundWaterZoneUpsert } from '../../../../@types/model/borehole/groundWaterZone/groundWaterZoneUpsert';
import { queryErrorHandler, querySuccessHandler, queryDeleteSuccessHandler } from '../../queryStateHandlers';
import GroundWaterZoneHttpService from '../../../../services/borehole/groundWaterZoneHttpService';
import { DELETE_GROUND_WATER_ZONE_KEY, GET_GROUND_WATER_ZONES_KEY, UPSERT_GROUND_WATER_ZONE_KEY } from '../../queryConstants';
import { UpsertTypeEnum } from '../../../../@types/enum/upsertType';

export const useGetGroundWaterZones = () => {
    const query = useQuery<Array<IGroundWaterZone>, Error>({
        queryKey: [GET_GROUND_WATER_ZONES_KEY],
        queryFn: () => GroundWaterZoneHttpService.getList(),
        onError: queryErrorHandler('Error loading Ground Water Zone.'),
    });

    return query;
};

export const useHandleUpsertGroundWaterZone = () => {
    const result = useMutation<IGroundWaterZone, Error, { upsert : IGroundWaterZoneUpsert; type : UpsertTypeEnum }>({
        mutationKey: [UPSERT_GROUND_WATER_ZONE_KEY],
        mutationFn: (args : { upsert : IGroundWaterZoneUpsert; type : UpsertTypeEnum }) => GroundWaterZoneHttpService.upsert(args.upsert, args.type),
        onError: queryErrorHandler('Error creating/updating Ground Water Zone.'),
        onSuccess: querySuccessHandler(GET_GROUND_WATER_ZONES_KEY, 'Ground Water Zone updated successfully.')
    });

    return result;
};

export const useHandleDeleteGroundWaterZone = () => {
    return useMutation<void, Error, number>({
        mutationKey: [DELETE_GROUND_WATER_ZONE_KEY],
        mutationFn: (contactUsId : number) => GroundWaterZoneHttpService.delete(contactUsId),
        onError: queryErrorHandler('Error deleting Ground Water Zone.'),
        onSuccess: queryDeleteSuccessHandler(DELETE_GROUND_WATER_ZONE_KEY, GET_GROUND_WATER_ZONES_KEY, 'Ground Water Zone inactivated successfully.')
    });
};